import React,{ Component } from "react";
import { Row, Col, Table, Modal, ModalHeader, Button, ModalBody, ModalFooter, Form, Container,
    FormGroup, Card, CardBody, CardHeader, ListGroup, ListGroupItem, Label} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import DateTimePicker from 'react-datetime-picker';
import { NotificationManager } from "react-notifications";
import { withRouter } from "react-router-dom";
import Proptypes from "prop-types";
import iconNo from "../../../../assets/images/icon_no.svg";
import iconYes from "../../../../assets/images/icon_yes.svg";
import LoadingSpinner from "../../../components/LoadingSpinner/index";
import DataTable from "../../../components/Table/Table";
import { renderField, required, password  } from "../../../utils/formValidations.js";
import {
    getUser,
    setUserPassword,
    getUserAttributes,
    addUserAttribute,
    updateUserAttribute,
    getUserUsageDump,
    getSubscriptionInfo,
    getAllProducts,
    setUserProfilePageInfo,
} from "../../../actions/actionUser";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";
import moment from "moment";
import { logout } from "../../../actions/actionLogin";
import {renderCheckbox, renderTextArea} from "../../../utils/formValidations";
import {getUserImages} from "../../../actions/actionDashboard";
import Select from "react-select";
import { PROGRAM_DATA } from "../../../constants/Constants.js";
import TooltipComponent from "../../Settings/TooltipComponent";

import ServiceBotSubscription from "../../../components/ServiceBot/Subscription/Subscription.js";
import ServiceBotSignup from "../../../components/ServiceBot/Signup/Signup.js";
import cross from "../../../../assets/images/cross.png";
import filtergray from "../../../../assets/images/filtergray.svg";
import filter from "../../../../assets/images/filter.svg";
import cancel from "../../../../assets/images/cancel.png";
import Pagination from '../../Pagination'
import { setThemeColor } from "../../../utils/helpers.js";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Profile",path:"/userProfile",isActive: true}
];

const validate = values => {
    const errors = {};
    if (values.newPassword !== values.confirmPassword) {
        errors.confirmPassword = "Passwords Do Not Match";
    }
    return errors;
};

class UserProfile extends Component{
    constructor(props) {
        super(props);

        this.state = {
            modal:false,
            password: "",
            confirmPassword: "",
            user: "",
            settingValue: "",
            tipsValue: "",
            auto_login: "",
            new_plan: null,
            toggle_control_panel: "",
            theme: "",
            chat_sfx: "",
            has_products: false,
            changeSubscriptionDisabled: false,
        };
		
        this.resetConfirm = this.resetConfirm.bind(this);
        this.resetPassword = this.resetPassword.bind(this);
        this.toggle = this.toggle.bind(this);
        this.renderDefaultImage = this.renderDefaultImage.bind(this);
        this.handleDefaultImageDropDown = this.handleDefaultImageDropDown.bind(this);
        this.setDefaultAttributeID = this.setDefaultAttributeID.bind(this);
        this.updateImageDefaultSuccess = this.updateImageDefaultSuccess.bind(this);
        this.updateImageDefaultError = this.updateImageDefaultError.bind(this);
        this.updateTips = this.updateTips.bind(this);
        this.updateTipsDefaultSuccess = this.updateTipsDefaultSuccess.bind(this);
        this.updateTipsDefaultError = this.updateTipsDefaultError.bind(this);
        this.renderAutoLogin = this.renderAutoLogin.bind(this);
        this.updateAutoLogin = this.updateAutoLogin.bind(this);
        this.updateAutoLoginSuccess = this.updateAutoLoginSuccess.bind(this);
        this.updateAutoLoginError = this.updateAutoLoginError.bind(this);
        this.renderToggleControlPanel = this.renderToggleControlPanel.bind(this);
        this.updateToggleControlPanel  = this.updateToggleControlPanel .bind(this);
        this.updateToggleControlPanelSuccess = this.updateToggleControlPanelSuccess.bind(this);
        this.updateToggleControlPanelError = this.updateToggleControlPanelError.bind(this);
        this.renderChatSFX = this.renderChatSFX.bind(this);
        this.updateChatSFX = this.updateChatSFX .bind(this);
        this.updateChatSFXSuccess = this.updateChatSFXSuccess.bind(this);
        this.updateChatSFXError = this.updateChatSFXError.bind(this);
        this.getProducts = this.getProducts.bind(this);
        this.selectPlan = this.selectPlan.bind(this);
        this.resetKeyConfirm = this.resetKeyConfirm.bind(this);
        this.updateSSHKey = this.updateSSHKey.bind(this);
        this.updateSSHKeySuccess = this.updateSSHKeySuccess.bind(this);
        this.updateSSHKeyError = this.updateSSHKeyError.bind(this);
        this.toggleKey = this.toggleKey.bind(this);
        this.downloadBlob = this.downloadBlob.bind(this);
        this.renderTheme = this.renderTheme.bind(this);
        this.updateTheme = this.updateTheme.bind(this);
        this.updateThemeSuccess = this.updateThemeSuccess.bind(this);
        this.updateThemeError = this.updateThemeError.bind(this);
    }

    resetKeyConfirm() {
        this.setState({ key_modal: !this.state.key_modal });
    }

    updateSSHKey(formData) {
        this.props.updateUserAttribute({
            "ssh_private_key": formData.ssh_private_key,
            "ssh_passphrase": formData.ssh_passphrase,
        }).
            then(() => { this.updateSSHKeySuccess() }).
            catch(() => { this.updateSSHKeyError() });
    }


    toggleKey() {
        this.setState({ key_modal: !this.state.key_modal });
        this.props.initialize({
            ssh_private_key: "",
            ssh_passphrase: ""
        });
    }
    updateSSHKeySuccess() {
        const { updateUserErrorMessage } = this.props;
        if (updateUserErrorMessage) {
            NotificationManager.error(updateUserErrorMessage, "Update SSH Keys", 5000);
        } else{
            NotificationManager.success("Successfully updated SSH Keys", "Update SSH Keys", 2000);
            this.setState({key_modal: false});
            this.props.initialize({ ssh_passphrase: "" , ssh_private_key: ""});
        }
        this.props.getUserAttributes()
            .then(() => this.setDefaultAttributeID());
    }

    updateSSHKeyError() {
        const { updateUserErrorMessage, updateUserAttrError } = this.props;
        if (updateUserAttrError) {
            NotificationManager.error(updateUserAttrError, "Update SSH Keys");
        } else if (updateUserErrorMessage) {
            NotificationManager.error(updateUserErrorMessage, "Update SSH Keys");
        } else
            NotificationManager.error("Error updating SSH Keys", "Update SSH Keys");
        this.props.getUserAttributes()
            .then(() => this.setDefaultAttributeID());
    }

    downloadBlob() {
        let jsonBlob = new Blob([this.state.ssh_public_key]);
        const blobUrl = URL.createObjectURL(jsonBlob);

        const link = document.createElement("a");

        link.href = blobUrl;
        link.download = 'id_rsa.pub';

        document.body.appendChild(link);

        link.dispatchEvent(
            new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window
            })
        );
        document.body.removeChild(link);
    };

    selectPlan(event) {
        this.setState({new_plan: event.target.value})
    }

    getProducts(){
        if (this.state.changeSubscriptionDisabled) {
            return;
        }
        this.setState({changeSubscriptionDisabled: true});
        this.props.getAllProducts()
            .then(() => {
                    this.setState({changeSubscriptionDisabled: false});
                   })
            .catch(() => {
                    this.setState({changeSubscriptionDisabled: false});
            });
    }

    resetConfirm(){
        this.setState({modal: !this.state.modal});
    }

    resetPassword(formData){
        this.props.setUserPassword(formData)
            .then(() => this.handlePasswordResetSuccess())
            .catch(() => this.handlePasswordResetFailure());
    }

    handlePasswordResetSuccess(){
        const {errorMessage} = this.props;
        if(errorMessage) {
            NotificationManager.error(errorMessage,"Reset Password", 3000);
        }
        else 
        {
            NotificationManager.success("Successfully Reset Password","Reset Password",3000);
            this.setState({modal: false});
            this.props.initialize({ newPassword: "" , password: "" , confirmPassword: "" });
            setTimeout(
                            function(){
                                this.handleLogout()
                            }.bind(this), 1000);
        }
    }

    handleLogout() {
            alert("You will now be logged out. Sign in with new credentials.");
            this.props.logout();
    }

    handlePasswordResetFailure(){
        const {resetPasswordError} = this.props;
        if(resetPasswordError){
            NotificationManager.error(resetPasswordError,"Reset Password", 3000);
        }
        else {
            NotificationManager.error("Failed to Reset Password","Reset Password", 3000);
        }
		
    }

    toggle(){
        this.setState({modal: !this.state.modal});
        this.props.initialize({ newPassword: "", password: "" , confirmPassword: "" });
    }

    componentDidMount(){
        this.props.getUser().then((res) => {
            this.setState({user: res.response.user});
        });
        this.props.getUserAttributes()
            .then(() => this.setDefaultAttributeID());
        this.props.getUserImages();
        this.props.getUserUsageDump();
        this.props.getSubscriptionInfo();
        this.props.getAllProducts().then((res) => {
            if (res && res.response && res.response.length > 0){
                this.setState({has_products:true});
            }
        });

    }

    setDefaultAttributeID() {
        const {userattributes} = this.props;
        this.setState(
            {
                settingValue: userattributes.default_image,
                tipsValue: userattributes.show_tips,
                auto_login: userattributes.auto_login_kasm,
                toggle_control_panel: userattributes.toggle_control_panel,
                chat_sfx: userattributes.chat_sfx,
                ssh_public_key: userattributes.ssh_public_key,
                theme: userattributes.theme
            }
        );
    }

    renderKasms(kasms){
        if(kasms){
            return(
                kasms.map((kasm, i) =>
                    <tr key={i}> 
                        <td>{kasm.kasm_id}</td>
                        <td>{moment.utc(kasm.start_date).local().format("L h:mm A")}</td>
                        <td>{moment.utc(kasm.expiration_date).local().format("L h:mm A")}</td>
                        <td>{moment.utc(kasm.keepalive_date).local().format("L h:mm A")}</td>
                    </tr>
                ));
        }         
    }

    renderGroups(groups){
        if (groups){
            return(
                groups.map((group, i) => 
                    <ListGroupItem key={i}>Group Name : {group.name}</ListGroupItem>
                ));
        }
    }

    handleDefaultImageDropDown(value){
        this.props.updateUserAttribute({"default_image": value.image_id})
            .then(() => this.updateImageDefaultSuccess())
            .catch(() => this.updateImageDefaultError());
        this.setState({settingValue: value.image_id});
    }

    updateImageDefaultSuccess() {
        const {updateUserErrorMessage} = this.props;
        if (updateUserErrorMessage) {
            NotificationManager.error(updateUserErrorMessage, "Update Default Image", 5000);
        } else
            NotificationManager.success("Successfully updated default image", "Update Default Image", 2000);
    }

    updateImageDefaultError() {
        const {updateUserErrorMessage, updateUserAttrError } = this.props;
        if (updateUserAttrError) {
            NotificationManager.error(updateUserAttrError, "Update Default Image");
        } else if (updateUserErrorMessage) {
            NotificationManager.error(updateUserErrorMessage, "Update Default Image");
        } else
         
        NotificationManager.error("Error updating default image", "Update Default Image");
    }

    renderDefaultImage(attr){
        const {availableKasms} = this.props;
        return(
            <tr>
                <td>
                    <span className="user_setting">
                        <TooltipComponent
                            description="The default Workspace Image to launch when clicking the Launch Now menu item. The Image is also used if Auto Launch Session is enabled."
                            name="Default Workspace Image"
                        />
                    </span>
                </td>
                <td >
                    {availableKasms &&
                        <Select
                            id="state-select"
                            autoFocus
                            value={this.state.settingValue}
                            placeholder="Please Select a Default Kasm"
                            options={availableKasms}
                            valueKey="image_id"
                            labelKey="friendly_name"
                            name="selected-state"
                            onChange={this.handleDefaultImageDropDown}
                        />
                        }
                </td>
            </tr>)
    }

    renderShowTips(){
        const {userattributes} = this.props;
        const options = [
            {value:true, label:'True'},
            {value:false, label:'False'}
        ];
        return(
            <tr>
                <td>
                    <span className="user_setting">
                        <TooltipComponent
                            description="Show helpful tips when launching a Kasm session."
                            name="Show Tips During Session"
                        />
                    </span>
                </td>
                <td >
                    {userattributes &&
                    <Select
                        autoFocus
                        value={this.state.tipsValue}
                        options={options}
                        onChange={this.updateTips}
                    />
                    }
                </td>
            </tr>)
    }

    updateTips(selectedOption){
        this.props.updateUserAttribute({"show_tips": selectedOption.value}).
        then(() => { this.updateTipsDefaultSuccess() }).
        catch(() => { this.updateTipsDefaultError() });
        this.setState({tipsValue: selectedOption.value});
    }

    updateTipsDefaultSuccess() {
        const {updateUserErrorMessage} = this.props;
        if (updateUserErrorMessage) {
            NotificationManager.error(updateUserErrorMessage, "Update Tips Selection", 5000);
        } else
            NotificationManager.success("Successfully updated Tips", "Update Tips", 2000);
    }

    updateTipsDefaultError() {
        const {updateUserErrorMessage, updateUserAttrError } = this.props;
        if (updateUserAttrError) {
            NotificationManager.error(updateUserAttrError, "Update Tips");
        } else if (updateUserErrorMessage) {
            NotificationManager.error(updateUserErrorMessage, "Update Tips");
        } else
            NotificationManager.error("Error updating Tips", "Update Tips");
    }

    renderAutoLogin(){
        const {userattributes} = this.props;
        const options = [
            {value:true, label:'True'},
            {value:false, label:'False'}
        ];
        return(
            <tr>
                <td>
                    <span className="user_setting">
                        <TooltipComponent
                            description="Automatically launch a Kasm session when logging in. The Default Workspace Image is used."
                            name="Auto Launch Session"
                        />
                    </span>
                </td>
                <td >
                    {userattributes &&
                    <Select
                        autoFocus
                        value={this.state.auto_login}
                        options={options}
                        onChange={this.updateAutoLogin}
                    />
                    }
                </td>
            </tr>)
    }

    updateAutoLogin(selectedOption){
        this.props.updateUserAttribute({"auto_login_kasm": selectedOption.value}).
        then(() => { this.updateAutoLoginSuccess() }).
        catch(() => { this.updateAutoLoginError() });
    }

    updateAutoLoginSuccess() {
        const {updateUserErrorMessage} = this.props;
        if (updateUserErrorMessage) {
            NotificationManager.error(updateUserErrorMessage, "Update Auto Login", 5000);
        } else
            NotificationManager.success("Successfully updated Auto Login", "Update Auto Login", 2000);
        this.props.getUserAttributes()
            .then(() => this.setDefaultAttributeID());
    }

    updateAutoLoginError() {
        const {updateUserErrorMessage, updateUserAttrError } = this.props;
        if (updateUserAttrError) {
            NotificationManager.error(updateUserAttrError, "Update Auto Login");
        } else if (updateUserErrorMessage) {
            NotificationManager.error(updateUserErrorMessage, "Update Auto Login");
        } else
            NotificationManager.error("Error updating Auto Login", "Update Auto Login");
        this.props.getUserAttributes()
            .then(() => this.setDefaultAttributeID());
    }

    renderToggleControlPanel(){
        const {userattributes} = this.props;
        const options = [
            {value:true, label:'True'},
            {value:false, label:'False'}
        ];
        return(
            <tr>
                <td>
                    <span className="user_setting">
                        <TooltipComponent
                            description="Open and close the control panel within a Kasm session by double clicking the CTRL key."
                            name="Toggle Control Panel"
                        />
                    </span>
                </td>
                <td >
                    {userattributes &&
                    <Select
                        autoFocus
                        value={this.state.toggle_control_panel}
                        options={options}
                        onChange={this.updateToggleControlPanel}
                    />
                    }
                </td>
            </tr>)
    }

    updateToggleControlPanel(selectedOption){
        this.props.updateUserAttribute({"toggle_control_panel": selectedOption.value}).
        then(() => { this.updateToggleControlPanelSuccess() }).
        catch(() => { this.updateToggleControlPanelError() });
    }

    updateToggleControlPanelSuccess() {
        const {updateUserErrorMessage} = this.props;
        if (updateUserErrorMessage) {
            NotificationManager.error(updateUserErrorMessage, "Update Toggle Control Panel", 5000);
        } else
            NotificationManager.success("Successfully updated Toggle Control Panel", "Update Toggle Control Panel", 2000);
        this.props.getUserAttributes()
            .then(() => this.setDefaultAttributeID());
    }

    updateToggleControlPanelError() {
        const {updateUserErrorMessage, updateUserAttrError } = this.props;
        if (updateUserAttrError) {
            NotificationManager.error(updateUserAttrError, "Update Toggle Control Panel");
        } else if (updateUserErrorMessage) {
            NotificationManager.error(updateUserErrorMessage, "Update Toggle Control Panel");
        } else
            NotificationManager.error("Error updating Auto Login", "Update Toggle Control Panel");
        this.props.getUserAttributes()
            .then(() => this.setDefaultAttributeID());
    }

    renderChatSFX(){
        const {userattributes} = this.props;
        const options = [
            {value:true, label:'True'},
            {value:false, label:'False'}
        ];
        return(
            <tr>
                <td>
                    <span className="user_setting">
                        <TooltipComponent
                            description="Enable sound effects for chat during shared sessions."
                            name="Chat Sound Effects"
                        />
                    </span>
                </td>
                <td >
                    {userattributes &&
                    <Select
                        autoFocus
                        value={this.state.chat_sfx}
                        options={options}
                        onChange={this.updateChatSFX}
                    />
                    }
                </td>
            </tr>)
    }

    updateChatSFX(selectedOption){
        this.props.updateUserAttribute({"chat_sfx": selectedOption.value}).
        then(() => { this.updateChatSFXSuccess() }).
        catch(() => { this.updateChatSFXError() });
    }

    updateChatSFXSuccess() {
        const {updateUserErrorMessage} = this.props;
        if (updateUserErrorMessage) {
            NotificationManager.error(updateUserErrorMessage, "Update Chat Sound Effects", 5000);
        } else
            NotificationManager.success("Successfully updated Chat Sound Effects", "Update Chat Sound Effects", 2000);
        this.props.getUserAttributes()
            .then(() => this.setDefaultAttributeID());
    }

    updateChatSFXError() {
        const {updateUserErrorMessage, updateUserAttrError } = this.props;
        if (updateUserAttrError) {
            NotificationManager.error(updateUserAttrError, "Update Chat Sound Effects");
        } else if (updateUserErrorMessage) {
            NotificationManager.error(updateUserErrorMessage, "Update Chat Sound Effects");
        } else
            NotificationManager.error("Error updating Chat Sound Effects", "Update Chat Sound Effects");
        this.props.getUserAttributes()
            .then(() => this.setDefaultAttributeID());
    }

    renderUsageDetails() {
        if (!this.props.usageDump) {
            return "No Usage";
        }

        const columns = [
            {
                type: "text",
                accessor: "image_friendly_name",
                name: "Image",
                filterable: true,
                sortable: true
            },
            {
                type: "date",
                accessor: "start_date",
                name: "Created",
                filterable: true,
                sortable: true
            },
            {
                type: "date",
                accessor: "destroyed_date",
                name: "Stopped On",
                filterable: true,
                sortable: true
            },
            {
                type: "text",
                accessor: "destroy_reason",
                name: "Stopped By",
                filterable: true,
                sortable: true
            },
            {
                type: "text",
                accessor: "usage_hours",
                name: "Usage (hours)",
                filterable: true,
                sortable: true
            },
        ];

        return (
            <DataTable
                id="user-profile"
                data={this.props.usageDump.account_dump}
                columns={columns}
            />
        )
    }

    renderTheme(){
        const {userattributes} = this.props;
        const options = [
            {value:'Auto', label:'Auto'},
            {value:'Dark', label:'Dark'},
            {value:'Light', label:'Light'}
        ];
        return(
            <tr>
                <td>
                    <span className="user_setting">
                        <TooltipComponent
                            description="Adjust the app theme. Auto will utilize the local systems OS theme settings."
                            name="Theme"
                        />
                    </span>
                </td>
                <td >
                    {userattributes &&
                    <Select
                        autoFocus
                        value={this.state.theme}
                        options={options}
                        onChange={this.updateTheme}
                    />
                    }
                </td>
            </tr>)
    }

    updateTheme(selectedOption){
        this.props.updateUserAttribute({"theme": selectedOption.value}).
        then(() => { this.updateThemeSuccess(selectedOption.value) }).
        catch(() => { this.updateThemeError() });
    }

    updateThemeSuccess(themeColor) {
        const {updateUserErrorMessage} = this.props;
        if (updateUserErrorMessage) {
            NotificationManager.error(updateUserErrorMessage, "Update Theme", 5000);
        }
        else {
           setThemeColor(themeColor);
           NotificationManager.success("Successfully Updated Theme", "Update Theme", 2000);
        }
        this.props.getUserAttributes()
            .then(() => this.setDefaultAttributeID());
    }

    updateThemeError() {
        const {updateUserErrorMessage, updateUserAttrError } = this.props;
        if (updateUserAttrError) {
            NotificationManager.error(updateUserAttrError, "Update Theme");
        } else if (updateUserErrorMessage) {
            NotificationManager.error(updateUserErrorMessage, "Update Theme");
        } else
            NotificationManager.error("Error Updating Theme", "Update Theme");
        this.props.getUserAttributes()
            .then(() => this.setDefaultAttributeID());
    }


    render(){
        if (this.props.getUsersLoading){
            return (<div> <LoadingSpinner /></div>);
        }

        const {handleSubmit, submitting, userattributes, usageDump, usageDumpLoading, subSummary, subInfoLoading, productList} = this.props;
        const {user} = this.state;

        const canResetPassword = user.realm === "local";

        return(
            <div className="profile-page">
                <BreadCrumbCompo routes={routes}/>  
                <Row>
                    <Col sm={{ size: 8, order: 3, offset: 2 }}>
                        <Card >
                            <CardHeader>
                                <strong>Profile</strong>
                                {canResetPassword && (
                                    <Button
                                        className="pull-right reset-btn"
                                        size="sm"
                                        color="primary"
                                        onClick={this.resetConfirm}>
                                        <i className="fa fa-key" aria-hidden="true"></i>Reset Password
                                    </Button>
                                )}
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">
                                        <div className="profile-table">
                                            <Table >
                                                <tbody>
                                                    <tr><td><h4>User Name</h4></td><td><p>{user.username}</p></td></tr>
                                                    <tr><td><h4>First Name</h4></td><td><p>{user.first_name?(user.first_name):("-")}</p></td></tr>
                                                    <tr><td><h4>Last Name</h4></td><td><p>{user.last_name?(user.last_name):("-")}</p></td></tr>
                                                    <tr><td><h4>Notes</h4></td><td><p>{user.notes?(user.notes):("-")}</p></td></tr>
                                                    <tr><td><h4>Locked</h4></td><td><p>{user.locked?(<img src={iconYes} alt="iconYes"/>):(<img src={iconNo} alt="iconNo"/>)}</p></td></tr>
                                                    <tr><td><h4>Disabled</h4></td><td><p>{user.disabled?(<img src={iconYes} alt="iconYes"/>):(<img src={iconNo} alt="iconNo"/>)}</p></td></tr>
                                                    <tr><td><h4>Organization</h4></td><td><p>{user.organization?(user.organization):("-")}</p></td></tr>
                                                    <tr><td><h4>Last Session</h4></td><td><p>{moment.utc(user.last_session).local().format("L h:mm A")}</p></td></tr>
                                                    <tr><td><h4>Phone</h4></td><td><p>{user.phone?(user.phone):("-")}</p></td></tr>
                                                </tbody>                          
                                            </Table>
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody> 
                        </Card>
                        {PROGRAM_DATA && PROGRAM_DATA.program_id ?
                            <Card>
                                <div>
                                    <CardHeader><strong>Program</strong></CardHeader>
                                    <CardBody>
                                        <h4>{PROGRAM_DATA.program_id}</h4>
                                    </CardBody>
                                </div>
                            </Card> : " "
                        }
                        {
                            user && user.program_id ?
                                <Card>
                                    <CardHeader><strong>Subscription Details</strong></CardHeader>
                                    <CardBody>
                                        Your subscription is managed by a third party.
                                    </CardBody>
                                </Card>
                                :
                                ""
                        }
                        { user && !user.program_id && this.state.has_products ?
                             <Card>
                            <CardHeader><strong>Subscription Details</strong></CardHeader>
                            <CardBody className="user-setting">
                                {
                                    !subInfoLoading && subSummary ?
                                        <React.Fragment>
                                          <ServiceBotSubscription
                                            email={user.username}
                                            hash={user.hash}
                                          />
                                        </React.Fragment>
                                    :
                                        <React.Fragment>
                                            <ServiceBotSignup
                                                email={user.username}
                                                hash={user.hash}
                                            />
                                        </React.Fragment>
                                    }
                            </CardBody>
                        </Card>

                            :
                            ""
                        }

                        {userattributes ?
                            <Card>
                                <div>
                                    <CardHeader><strong>Settings</strong></CardHeader>
                                    <CardBody>
                                        <Table>
                                            <tbody>
                                                {this.renderAutoLogin()}
                                                {this.renderChatSFX()}
                                                {this.renderDefaultImage(userattributes)}
                                                {this.renderShowTips()}
                                                {this.renderToggleControlPanel()}
                                                {this.renderTheme()}
                                                
                                            </tbody>
                                        </Table>
                                    </CardBody>
                                </div>
                            </Card> : " "
                        }

                        {userattributes ?
                            <Card>
                                <div>
                                    <CardHeader><strong>SSH Keys</strong></CardHeader>
                                    <CardBody>
                                        <Table>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <span className="user_setting">
                                                            <TooltipComponent
                                                                description="The SSH Public key that is automatically injected into each new Kasm session if allowed by administrator policies."
                                                                name="SSH Public Key"
                                                            />
                                                        </span>
                                                    </td>
                                                    <td >
                                                        <div>
                                                            <Button className="pull-right btn-width download-btn" size="sm" color="success" onClick={this.downloadBlob}>
                                                                <i className="fa fa-download" aria-hidden="true"></i>{" "}Download
                                                            </Button>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="user_setting">
                                                            <TooltipComponent
                                                                description="Update the SSH key pair that is automatically injected into each new Kasm session if allowd by adminitrator policies. "
                                                                name="New Key Pair"
                                                            />
                                                        </span>
                                                    </td>
                                                    <td >
                                                        <div>
                                                            <Button className="pull-right btn-width download-btn" size="sm" color="success" onClick={this.resetKeyConfirm}>
                                                                <i className="fa fa-upload" aria-hidden="true"></i>{" "}Upload New Key Pair
                                                            </Button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </CardBody>
                                </div>
                            </Card> : " "
                        }

                        {user && user.groups && user.groups.length > 0 ?
                            <Card>
                                <div>
                                    <CardHeader><strong>Groups</strong></CardHeader>
                                    <CardBody>
                                        <ListGroup>{this.renderGroups(user.groups)}</ListGroup>
                                    </CardBody>
                                </div> 
                            </Card> : " "
                        }
                         
       
                        {user && user.kasms && user.kasms.length > 0 ?
                            <Card>
                                <div>
                                    <CardHeader><strong>Active Sessions</strong></CardHeader>
                                    <CardBody>
                                        <Row>
                                            <Col xs="12">
                                                <Table responsive bordered className="align_top">
                                                    <thead>
                                                        <tr>
                                                            <th>Id</th>
                                                            <th>Start Date</th>
                                                            <th>Expiration Date</th>
                                                            <th>Last Accessed</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>{user ? this.renderKasms(user.kasms) : " "}</tbody>
                                                </Table>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </div>       
                            </Card> : " "
                        }
                        { !usageDumpLoading ?
                            <Card>
                                <div>
                                    <CardHeader>
                                    <div className="title-head"> 
                                        <strong>Session Usage Details:&nbsp;</strong>Last 30 Days</div></CardHeader>
                                    <CardBody className="p-0">
                                        {this.renderUsageDetails()}
                                    </CardBody>
                                </div>
                            </Card> : " "
                        }

                        <Modal 
                            isOpen={this.state.modal} 
                            toggle={this.toggle} 
                            className="launch-modal"
                            backdrop={true}
                        >
                            <div>
                                <div className="profile-close-icon">
                                    <button className="close-icon" onClick={this.toggle}>
                                        <img src={cross} alt="close" />
                                    </button>
                                </div>
                            </div>
                            <Form onSubmit={handleSubmit(this.resetPassword)}>
                                <ModalBody>
                                    <FormGroup>
                                        <Row>
                                            <Col sm="5">
                                                <label className="requiredasterisk">Current Password: </label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Field 
                                                    id="password"
                                                    type="password" 
                                                    name="password"
                                                    component={renderField} 
                                                    validate={[required]}
                                                /> 
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                    <FormGroup>
                                        <Row>
                                            <Col sm="5">
                                                <label className="requiredasterisk">New Password: </label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Field 
                                                    id="newPassword"
                                                    type="password"
                                                    name="newPassword"
                                                    component={renderField} 
                                                    validate={[required, password]}
                                                /> 
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                    <FormGroup>
                                        <Row>
                                            <Col sm="5">
                                                <label className="requiredasterisk">Confirm Password: </label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Field
                                                    id="confirmPassword"
                                                    type="password"
                                                    name="confirmPassword"
                                                    component={renderField}
                                                    validate={[required, password]}
                                                />                                            
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                    {user.two_factor ?
                                        <FormGroup>
                                            <Row>
                                                <Col sm="6">
                                                    <label>Reset Two Factor Authentication</label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Field name="set_two_factor"
                                                           id="set_two_factor"
                                                           type="checkbox"
                                                           check={false}
                                                           component={renderCheckbox}
                                                    />
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                    : ""}

                                    <Row className="kasmCardFooter">
                                        <Col md="12">
                                            <Button
                                            color="primary"
                                            disabled={submitting}
                                            className="btn-block"
                                            style={{ cursor: "pointer" }}
                                            type="submit"
                                            >
                                                Reset Password
                                            </Button>
                                        </Col>
                                    </Row>
                                </ModalBody>
                            </Form>
                        </Modal>

                        <Modal 
                            isOpen={this.state.key_modal} 
                            toggle={this.toggleKey} 
                            className="launch-modal"
                            backdrop={true}
                        >
                            <div>
                                <div className="profile-close-icon">
                                    <button className="close-icon" onClick={this.toggleKey}>
                                        <img src={cross} alt="close" />
                                    </button>
                                </div>
                            </div>
                            <Form onSubmit={handleSubmit(this.updateSSHKey)}>
                                <ModalBody>
                                    <FormGroup>
                                        <Row>
                                            <div className="col-sm-12">Enter the private key below and the passphrase for the key if required.
                                            The public key will be extracted from the private key. The passhrpase is not stored.
                                            </div>
                                        </Row>
                                        <br></br>
                                        <Row>
                                            <Col sm="8">
                                                <label className="requiredasterisk">SSH Private Key (Type: RSA, Format: PEM)</label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Field
                                                    id="ssh_private_key"
                                                    type="ssh_private_key"
                                                    name="ssh_private_key"
                                                    component={renderTextArea}
                                                    validate={[required]}
                                                    placeholder="-----BEGIN RSA PRIVATE KEY-----&#10;...&#10;-----END RSA PRIVATE KEY-----"
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm="8">
                                                <label>SSH Private Key Passphrase</label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Field
                                                    id="ssh_passphrase"
                                                    type="ssh_passphrase"
                                                    name="ssh_passphrase"
                                                    component={renderField}
                                                />
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                    <Row className="kasmCardFooter">
                                        <Col md="12">
                                            <Button
                                            color="primary"
                                            disabled={submitting}
                                            className="btn-block"
                                            style={{ cursor: "pointer" }}
                                            type="submit"
                                            >
                                               Upload New Key Pair
                                            </Button>
                                        </Col>
                                    </Row>
                                </ModalBody>
                            </Form>
                        </Modal>  
                        <Modal className="datetimeModal user-modal" zIndex={999999} isOpen={this.state.isShowPicker} toggle={this.togglePickerModal} >
                            <ModalHeader toggle={()=>{
                                const cancelCreate = this.state.activeDateFilter === "created" ;
                                const cancelStop =  this.state.activeDateFilter === "stopped"
                                if (cancelCreate){
                                    this.setState({
                                        isCreationFilter : false,
                                    }) 
                                } else if (cancelStop){
                                    this.setState({
                                        isStoppedFilter : false
                                    })
                                }
                                this.togglePickerModal()
                                }}
                            >
                                Select Date and Time
                            </ModalHeader>
                            <ModalBody>
                                <Row>
                                    <Col>
                                        <div className="date-outer">
                                            <h6 className="title-label">Start Date</h6>
                                            <DateTimePicker
                                                clearIcon={null}
                                                required={true}
                                                onChange={this.changeStartDate}
                                                value={this.state.startDate}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className="date-outer">
                                            <h6 className="title-label">End Date</h6>
                                                <DateTimePicker
                                                    clearIcon={null}
                                                    required={true}
                                                    onChange={this.changeEndDate}
                                                    value={this.state.endDate}
                                                />
                                        </div>
                                    </Col>
                                </Row>
                            </ModalBody>
                            <ModalFooter>
                                <button size="sm"
                                        color="basic"  
                                        className="cancel-bttn"  
                                        onClick={() => {
                                            const cancelCreate = this.state.activeDateFilter === "created" ;
                                            const cancelStop =  this.state.activeDateFilter === "stopped"
                                            if (cancelCreate){
                                                this.setState({
                                                    isShowPicker : false,
                                                    isCreationFilter : false,
                                                }) 
                                            } else if (cancelStop){
                                                this.setState({
                                                    isShowPicker : false,
                                                    isStoppedFilter : false
                                                })
                                            }
                                        }} 
                                >
                                    Cancel
                                </button>
                                <button 
                                    className="update-bttn"
                                    onClick={()=>this.filterDateData(usageDump.account_dump)}
                                    size="sm"  
                                    color="primary" 
                                >
                                    Update
                                </button>
                            </ModalFooter>
                        </Modal>
                    </Col>
                </Row>
            </div>
        );
    }
}

UserProfile.propTypes = {
    setUserPassword: Proptypes.func.isRequired,
    getUserAttributes: Proptypes.func.isRequired,
    updateUserAttribute: Proptypes.func.isRequired,
    errorMessage: Proptypes.func,
    submitting:  Proptypes.bool,
    getUserImages: Proptypes.func.isRequired,
    initialize: Proptypes.func,
    className: Proptypes.func,
    getUsersLoading: Proptypes.func,
    resetPasswordError: Proptypes.func,
    handleSubmit: Proptypes.func,
    availableKasms: Proptypes.array,
    attribute: Proptypes.object,
    updateUserAttrError: Proptypes.string,
    updateUserErrorMessage: Proptypes.string
};

let ProfileUserFormWithRouter = withRouter(UserProfile);

let ProfileUserForm = connect(state => 
    ({
        user: state.user.user || [],
        getUsersLoading: state.user.getUsersLoading || null,
        errorMessage: state.user.errorMessage || null,
        userattributes: state.user.userattributes || null,
        availableKasms: state.dashboard.availableKasms,
        attribute: state.user.attribute || null,
        usageDump: state.user.usageDump,
        subSummary: state.user.subSummary,
        subInfoLoading: state.user.subInfoLoading,
        usageDumpLoading: state.user.usageDumpLoading,
        usageDumpError: state.user.usageDumpError,
        productList: state.user.productList,
        createSub: state.user.createSub,
        updateUserAttrError: state.user.updateUserAttrError,
        updateUserErrorMessage: state.user.updateUserErrorMessage,
        pages : {pageSize : state.user.userProfilePageSize, pageNo : state.user.userProfilePageNo},
    }),
dispatch => 
    ({  
        setUserPassword: (password) => dispatch(setUserPassword(password)),
        getUser: () => dispatch(getUser()),
        getUserAttributes: () => dispatch(getUserAttributes()),
        getUserUsageDump: (data) => dispatch(getUserUsageDump(data)),
        updateUserAttribute: (data) => dispatch(updateUserAttribute(data)),
        getUserImages: (payload_data) => dispatch(getUserImages(payload_data)),
        getSubscriptionInfo: () => dispatch(getSubscriptionInfo()),
        getAllProducts: () => dispatch(getAllProducts()),
        logout: (logout_data) => dispatch(logout(logout_data)),
        setPageInfo : (data)=> dispatch(setUserProfilePageInfo(data)),

    }))(ProfileUserFormWithRouter);

export default reduxForm({
    form: "profileuserForm",
    validate
})(ProfileUserForm);